import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import PageLoader from '../../../../../../component/PageLoader';

export default function GeneralInvoice({ setError, error, setForm, form, loader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (key === 'invoice_password') {
			var newError = { ...error };
			if (value) {
				delete newError.invoice_password;
			} else {
				newError[key] = 'Please enter password in the field.';
			}
			setError(newError);
		}
	};
	return (
		<div>
			{loader.isGetData && loader.isLoader ? (
				<PageLoader />
			) : (
				<div className="p-4">
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">Allow Editing Sales Invoice</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.allow_editing_sales_invoice}
									id="flexCheckDefault"
									onChange={(e) => {
										if (form.allow_editing_sales_invoice) {
											var newError = { ...error };
											delete newError.invoice_password;
											setError(newError);
										}
										handleFormData(
											'allow_editing_sales_invoice',
											!form.allow_editing_sales_invoice,
										);
									}}
								/>
							</div>
						</div>
					</div>
					{form.allow_editing_sales_invoice && (
						<div>
							<div className="row align-items-center my-2">
								<div className="col-3 text-sm font-medium text-start">
									Allow Editing Sent Invoice
								</div>
								<div className="col-6 my-2">
									<div className="form-check">
										<input
											class="form-check-input"
											type="checkbox"
											checked={form.allow_editing_sent_invoice}
											id="flexCheckDefault"
											onChange={(e) =>
												handleFormData(
													'allow_editing_sent_invoice',
													!form.allow_editing_sent_invoice,
												)
											}
										/>
									</div>
								</div>
							</div>
							<div className="row align-items-center my-2">
								<div className="col-3 text-sm font-medium text-start">Password</div>
								<div className="col-6 my-2">
									<InputField
										type="password"
										value={form?.invoice_password}
										placeholder="Password"
										label=""
										onChange={(value) => handleFormData('invoice_password', value)}
										error={error?.invoice_password}
										required
										autoComplete="invoice-password"
										showPasswordIcon
										showPasswordIconWithoutLabel={true}
									/>
								</div>
							</div>
						</div>
					)}
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">
							Print payment QR code on invoice
						</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.print_payment_qr_code}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData('print_payment_qr_code', !form.print_payment_qr_code)
									}
								/>
							</div>
						</div>
					</div>
					<div
						className="fs-4 fw-bold text-start py-4"
						style={{ color: '#3B58FF' }}
					>
						Notification and Alert
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">
							Payment Notification to Owner
						</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.payment_notification_to_owner}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData(
											'payment_notification_to_owner',
											!form.payment_notification_to_owner,
										)
									}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">
							Payment Received Notification to Customer
						</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.payment_received_notification_to_customer}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData(
											'payment_received_notification_to_customer',
											!form.payment_received_notification_to_customer,
										)
									}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">Terms & Conditions</div>
						<div className="col-6 my-2">
							<InputField
								type="text"
								value={form?.terms_and_conditions}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('terms_and_conditions', value)}
								error={error?.terms_and_conditions}
								required
								autoComplete="new-password"
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 text-sm font-medium text-start">Customer Notes</div>
						<div className="col-6 my-2">
							<InputField
								type="text"
								value={form?.customer_notes}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('customer_notes', value)}
								error={error?.customer_notes}
								required
								autoComplete="new-customer-notes"
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
